import { DownloadIcon } from "lucide-react"
import { useEffect, useRef } from "react"

/** Shown on the login page once the OTP is verified and the export download has started (T780). */
export const ExportDownloading = () => {
  const headingRef = useRef<HTMLHeadingElement>(null)
  // The form that held focus is gone: move focus to the heading so keyboard and screen-reader users land here.
  useEffect(() => headingRef.current?.focus(), [])
  return (
    <div className="w-full max-w-md text-center">
      <DownloadIcon aria-hidden="true" className="text-primary mx-auto size-8" />
      <h1 ref={headingRef} tabIndex={-1} className="mt-4 text-2xl font-bold tracking-tight">
        Your export is downloading
      </h1>
      <p role="status" className="text-muted-foreground mt-2 text-sm">
        You&apos;re signed in. Your download should start in a moment.
      </p>
      <a
        href="/"
        className="text-primary mt-6 inline-flex min-h-11 items-center text-sm font-medium underline-offset-4 hover:underline min-[769px]:min-h-6"
      >
        Back to the app
      </a>
    </div>
  )
}
